const breakpointName = (breakpoint = {}) => breakpoint.name === 'default' ? 'xl' : breakpoint.name;
const hasBreakpoint = (classes, name) => classes.some(className => className.startsWith(`col-${name}`));
export const hasSizing = data => !!data.cqResponsive && !!data.cqResponsive.deviceBreakpoints;
export const progressiveGridSizing = (classes, sizing, base = 12, setDefaultValue = false) => {
    const clazzes = Array.isArray(classes) ? classes : [classes];
    ((sizing === null || sizing === void 0 ? void 0 : sizing.deviceBreakpoints) || []).forEach(breakpoint => {
        const { width = '12', offset = '0', visible = true } = breakpoint;
        if (!visible) {
            return clazzes.push(`col-${breakpointName(breakpoint)}-hide`);
        }
        const sanitizedOffset = parseInt(offset, 10) || 0;
        clazzes.push(`col-${breakpointName(breakpoint)}-${width}of${base}`);
        return clazzes.push(`col-${breakpointName(breakpoint)}-offset-${sanitizedOffset}of${base}`);
    });
    const defaultValues = [];
    if (setDefaultValue) {
        for (const breakpoint of ['xs', 'sm', 'md', 'lg', 'xl']) {
            if (hasBreakpoint(clazzes, breakpoint))
                break;
            defaultValues.push(`col-${breakpoint}-12of12`);
            defaultValues.push(`col-${breakpoint}-offset-0of12`);
        }
    }
    return [...defaultValues, ...clazzes];
};
export const isBreakpointLargerThanX = (cqResponsive, name, largerThan) => {
    var _a;
    const deviceBreakpoints = (cqResponsive === null || cqResponsive === void 0 ? void 0 : cqResponsive.deviceBreakpoints) || [];
    const breakpointSize = (_a = deviceBreakpoints.find(breakpoint => breakpoint.name === name)) === null || _a === void 0 ? void 0 : _a.width;
    if (!breakpointSize)
        return false;
    return Number(breakpointSize) > largerThan;
};
//# sourceMappingURL=gridUtils.js.map